import Slider from '@ant-design/react-slick'
import commerceConfig from '@commerce/config'
import { PrismicImage } from '@lib/prismic'
import cn from 'classnames'
import Image from 'next/image'
import Link from 'next/link'
import 'slick-carousel/slick/slick-theme.css'
import 'slick-carousel/slick/slick.css'
type BannerItem = {
  desktop_image: PrismicImage
  mobile_image?: PrismicImage
  link?: string
}
interface props {
  primary: {
    full_width: boolean
  }
  items: BannerItem[]
  applyWrapper?: boolean
}
const BannerV2 = ({ primary, items, applyWrapper = true }: props) => {
  const {
    config: { defaultAlt },
  } = commerceConfig
  const fullWidth = primary?.full_width
  const numberOfItems = items?.length
  const renderBanner = (BannerItem: BannerItem) => {
    const desktopImage = BannerItem?.desktop_image
    const mobileImage =
      BannerItem?.mobile_image && BannerItem?.mobile_image?.url ? BannerItem?.mobile_image : desktopImage
    const link = BannerItem?.link
    if (!desktopImage) return <></>
    return (
      <section className={cn({ 'tablet:wrapper': !fullWidth && applyWrapper })}>
        {link ? (
          <Link href={link} passHref>
            <>
              <div className="tablet:block hidden w-full relative">
                <Image
                  src={`${decodeURI(desktopImage?.url)}`}
                  alt={desktopImage?.alt || defaultAlt}
                  className="object-cover"
                  width={desktopImage?.dimensions?.width}
                  height={desktopImage?.dimensions?.height}
                  style={{ width: '100%' }}
                  placeholder="blur"
                  blurDataURL={`${decodeURI(desktopImage?.url)}&blur=300`}
                />
              </div>
              <div className="block w-full tablet:hidden ">
                <Image
                  src={`${decodeURI(mobileImage?.url)}`}
                  alt={mobileImage?.alt || defaultAlt}
                  width={mobileImage?.dimensions?.width}
                  height={mobileImage?.dimensions?.height}
                  className="object-cover"
                  style={{ width: '100%' }}
                  placeholder="blur"
                  blurDataURL={`${decodeURI(mobileImage?.url)}&blur=300`}
                />
              </div>
            </>
          </Link>
        ) : (
          <>
            <div className="tablet:block hidden w-full relative">
              <Image
                src={`${decodeURI(desktopImage?.url)}`}
                alt={desktopImage?.alt || defaultAlt}
                className="object-cover"
                width={desktopImage?.dimensions?.width}
                height={desktopImage?.dimensions?.height}
                style={{ width: '100%' }}
                placeholder="blur"
                blurDataURL={`${decodeURI(desktopImage?.url)}&blur=300`}
              />
            </div>
            <div className="block w-full tablet:hidden ">
              <Image
                src={`${decodeURI(mobileImage?.url)}`}
                alt={mobileImage?.alt || defaultAlt}
                width={mobileImage?.dimensions?.width}
                height={mobileImage?.dimensions?.height}
                className="object-cover"
                style={{ width: '100%' }}
                placeholder="blur"
                blurDataURL={`${decodeURI(mobileImage?.url)}&blur=300`}
              />
            </div>
          </>
        )}
      </section>
    )
  }
  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 6000,
    pauseOnHover: false,
    slidesToShow: 1,
    slidesToScroll: 1,
  }
  return (
    <>
      {numberOfItems > 1 ? (
        <div>
          <Slider {...sliderSettings} className="dynamic-banner-slider -mb-3">
            {items.map((item, index) => (
              <div key={index}>{renderBanner(item)}</div>
            ))}
          </Slider>
        </div>
      ) : (
        renderBanner(items[0])
      )}
      <style jsx global>
        {`
          .dynamic-banner-slider .slick-dots {
            bottom: 18px !important;
            position: absolute;
            display: flex !important;
            justify-content: center;
            align-items: center;
            width: 100%;
            margin: 0;
            padding: 0;
            list-style: none;
          }

          .dynamic-banner-slider .slick-dots li {
            position: relative;
            display: inline-block;
            width: 8px;
            height: 8px;
            margin: 0 8px;
            padding: 0;
            cursor: pointer;
          }

          .dynamic-banner-slider .slick-dots li button {
            font-size: 0;
            line-height: 0;
            display: block;
            width: 8px;
            height: 8px;
            padding: 0;
            cursor: pointer;
            color: transparent;
            border: 0;
            outline: none;
            background: rgba(0, 0, 0, 0.25);
            border-radius: 50%;
            transition: all 0.3s ease;
          }

          .dynamic-banner-slider .slick-dots li.slick-active button {
            background: rgba(255, 255, 255, 1);
          }

          .dynamic-banner-slider .slick-dots li button:before {
            display: none;
          }
          .dynamic-banner-slider .slick-slide {
            margin: 0 !important;
            padding: 0 !important;
          }
          .dynamic-banner-slider .slick-slide > div {
            margin: 0 !important;
            padding: 0 !important;
          }
        `}
      </style>
    </>
  )
}

export default BannerV2
